module.exports = __webpack_public_path__ + "media/truth_initiative_pet_protest/entry-page-background-dcb4e728.jpg";